import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import InappAddNewPopup from './InappAddNewPopup';

const useStyles = makeStyles(() => ({
  addressHeading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  addressText: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
    whiteSpace: 'pre-wrap',
  },
  container: {
    overflow: 'auto',
    width: '281px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  editButton: {
    height: '35px',
    marginRight: '10px',
  },
  editDiv: {
    marginTop: '20px',
  },
}));

const LeftSideInapp = (props) => {
  const classes = useStyles();
  const inappDetails = useSelector((state) => state.inappData.selectedInappDetails);
  const [isAddnewPopupOpen, setisAddnewPopupOpen] = React.useState(false);

  const closeAddNewInapp = () => {
    setisAddnewPopupOpen(false);
  };

  return (
    <>
      <section className={props.customStyles}>
        <Grid
          className={classes.container}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item>
            <p className={classes.addressHeading}>NAME</p>
            <p className={classes.addressText}>{inappDetails.title}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>DESCRIPTION</p>
            <p className={classes.addressText}>{inappDetails.description}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>TYPE</p>
            <p className={classes.addressText}>{inappDetails.type}</p>
          </Grid>
          {inappDetails.type === 'VIDEO' ? (
            <Grid item>
              <p className={classes.addressHeading}>SUB-TYPE</p>
              <p className={classes.addressText}>{inappDetails.subType}</p>
            </Grid>
          ) : null}
          {inappDetails.type === 'CUSTOM' || inappDetails.type === 'FEATURE_INTRO' ? (
            <Grid item>
              <p className={classes.addressHeading}>SUB-TYPE</p>
              <p className={classes.addressText}>{inappDetails.subType}</p>
            </Grid>
          ) : (
            <Grid item>
              <p className={classes.addressHeading}>CONTENT URL</p>
              <p className={classes.addressText}>{inappDetails.contentUrl || '-'}</p>
            </Grid>
          )}
          <Grid item>
            <p className={classes.addressHeading}>EXPIRY</p>
            <p className={classes.addressText}>{inappDetails.expiry}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>EVENT</p>
            <p className={classes.addressText}>{inappDetails.event}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>CRON EXPRESSION</p>
            <p className={classes.addressText}>{inappDetails.cronExpression || '-'}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>FREQUENCY</p>
            <p className={classes.addressText}>{inappDetails.frequency || '-'}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>STATIC PROPS</p>
            <p className={classes.addressText}>{JSON.stringify(inappDetails.staticProps, undefined, 2)}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>STATUS</p>

            <p className={classes.addressText}>{inappDetails.enabled ? 'Enabled' : 'Disabled'}</p>
          </Grid>
        </Grid>
      </section>
      <div className={classes.editDiv}>
        <Button
          variant="contained"
          color="primary"
          focusRipple={false}
          onClick={() => {
            setisAddnewPopupOpen((flag) => !flag);
          }}
          className={classes.editButton}
        >
          Edit
        </Button>
      </div>
      {isAddnewPopupOpen && (
        <InappAddNewPopup
          close={closeAddNewInapp}
          add={false}
          selectedData={inappDetails}
          refreshData={props.fetchData}
        />
      )}
    </>
  );
};

export default LeftSideInapp;
